import { SvgIcon } from '@mui/material';
import { ReactComponent as VoucherIconSVG } from "./voucher-icon.svg";

export default function IconVoucherNone(props) {
  return <SvgIcon {...props} component={VoucherIconSVG} viewBox="0 0 26 15" />;
}